<template>
  <div class="main mplus refly">
    <Header class="header-component" page="event"></Header>
    <div class="event box">
      <div class="event-title josefin title-text uppercase refly">
        event & present
      </div>
      <div class="event-inner box">
        <div class="head refly"><span class="head-text mplus">【全公演】スマホ撮影可能の<br class="brsp">スペシャルカーテンコール実施！</span></div>
        <span class="bolder">今回も全公演、写真・動画撮影OKのスペシャルカーテンコールを実施いたします！</span><br />
        ぜひ「#ジュエステカテコ」のハッシュタグをつけてSNSに投稿してください！<br />
        <span class="sq">■</span><span class="bolder">対象公演：</span>全公演<br />
        <span class="sq">■</span><span class="bolder">注意事項</span><br />
        携帯電話・スマートフォンのみ撮影可能。一眼レフカメラなどのカメラ機材はご使用いただけません。<br />
        フラッシュのご使用は、ほかのお客様のご迷惑になりますのでお控えください。<br />
        公演中指示があるまでは、スマートフォン・携帯電話は電源からお切りくださいますようお願いいたします。<br />
        <div class="head refly"><span class="head-text mplus">入場者特典</span></div>
        <span class="bolder"><span class="blue-text">対象公演のご来場者全員</span>に、各ユニットの<span
            class="blue-text">原作描き下ろしイラストを使用したコースター</span>（非売品）を1枚プレゼント！</span><br />
        MAISY公演はMAISYのイラスト5種、Re:Fly公演はRe:Flyのイラスト5種、エメ☆カレ公演はエメ☆カレのイラスト5種を、各回ランダムでお渡しいたします。<br />
        <div class="tokuten-image-box"><img src="img/maisy_tokuten.png" alt="" class="tokuten-image" /><img src="img/refly_tokuten.png" alt="" class="tokuten-image" /><img src="img/emekare_tokuten.png" alt="" class="tokuten-image" /></div>
        <div class="tokuten-coaster-text">※画像はイメージです。実際の商品とは異なる場合があります。</div>
        <span class="sq">■</span><span class="bolder">MAISY公演</span><br />
        <time datetime="2023-07-20T14:00">7月20日(木) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-21T19:00">7月21日(金) 19:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-25T14:00">7月25日(火) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-28T19:00">7月28日(金) 19:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-08-01T14:00">8月1日(火) 14:00</time><br />
        <span class="sq">■</span><span class="bolder">Re:Fly公演</span><br />
        <time datetime="2023-07-19T19:00">7月19日(水) 19:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-21T14:00">7月21日(金) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-25T19:00">7月25日(火) 19:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-26T14:00">7月26日(水) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-28T14:00">7月28日(金) 14:00</time><br />
        <span class="sq">■</span><span class="bolder">エメ☆カレ公演</span><br />
        <time datetime="2023-07-19T14:00">7月19日(水) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-26T19:00">7月26日(水) 19:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-07-27T14:00">7月27日(木) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-08-02T14:00">8月2日(水) 14:00</time><span class="bolder liteblue-text">／</span><time
          datetime="2023-08-03T19:00">8月3日(木) 19:00</time><br />
        <br />
        <span class="sq">■</span><span class="bolder">注意事項</span>
        <ul class="large">
          <li>※絵柄はお選びいただけません。また交換などはいたしかねます。</li>
          <li>※劇場周辺でのトレーディング行為はご遠慮ください。</li>
          <li>※特典は予告なく変更になる場合がございます。</li>
          <li>※ご来場時限定のプレゼントです。ご観劇日当日にお受け取りくださいますようお願いいたします。発送等の対応はできませんのであらかじめご了承ください。</li>
        </ul>
        <div class="head refly"><span class="head-text mplus">席種特典</span></div>
        <span class="bolder">席種により下記特典をご用意いたしました！</span><br />
        <br />

        <div class="item"><span class="bolder"><span class="seat-s">S席</span>&nbsp;…………………15,000円</span><br
            class="brsp">（1F 1〜3列目／<span class="blue-text bolder">シークレットライブ・お見送り付）</span></div>
        <div class="item"><span class="bolder">A席……………………9,500円</span><br class="brsp">（1F 4〜5列目／<span
            class="blue-text bolder">お見送り付</span>）</div>
        <div class="item"><span class="bolder"><span class="bench">1Fベンチシート</span>&nbsp;…10,000円</span><br
            class="brsp">（<span class="blue-text bolder">お見送り付</span>）</div>
        <div class="item"><span class="bolder"><span class="seat-2f">2F席</span>&nbsp;&nbsp;………………11,000円</span><br
            class="brsp">（<span class="blue-text bolder">シークレットライブ・お見送り付</span>）</div>
        <ul class="large">
          <li>※全席指定・税込</li>
          <li>※B席&#x3000;5,500円（1F 6～7列目）には特典がございませんので、ご注意ください。</li>
        </ul>
        <hr class="divider" />

        <span class="sq">■</span><span class="bolder">特典内容</span><br />
        <div class="bonus-item"><span class="blue-text bolder">・シークレットライブ</span><br />
          終演後、タイトルユニットが1曲のみのライブを開催！対象のお座席のお客様のみが参加可能です。<br />
          <ul class="large">
            <li>※対象のお客様はご自身のお座席にてご覧ください。</li>
            <li>※終演後、対象外のお客様が退場した後に実施いたしますため、準備に多少お時間をいただきます。</li>
          </ul>
        </div>
        <div class="bonus-item"><span class="blue-text bolder">・お見送り</span><br />
          毎公演終演後、キャスト5名によるお見送りを実施いたします！
          <ul class="large">
            <li>※お見送りでは、列の流れを止める行為やキャストとの会話はご遠慮ください。</li>
            <li>※出演キャストは下記のスケジュールをご確認ください。</li>
          </ul>
        </div>
        <hr class="divider" />
        <div class="ticket-info"><span class="bolder"><span class="blue-text">※</span>チケットのお申し込みについては<router-link
              class="title-link-text break-all" tag="span" :to="`/schedule`" key="0">【schedule &
              ticket】</router-link>をご確認ください。</span><br />
          <div class="mitt"><span class="sq">■</span><span class="bolder">チケットに関するお問い合わせ</span><br />
            Mitt：03-6265-3201（平日<time datetime="12:00">12:00</time>〜<time datetime="17:00">17:00</time>）</div>
        </div>
        <div class="divider wide refly"></div>


        <div class="event-schedule">
          <div class="josefin title-text uppercase blue-text">
            event & present <br class="brsp">schedule
          </div>
          <div class="schedule-title-jp black-text bolder">入場者＆席種特典スケジュール</div>
          <div class="event-table">
            <div class="row">
              <div class="date">
                <div class="month"></div>
                <div class="day"></div>
              </div>
              <div class="time"></div>
              <div class="coaster">
                <div class="inner"><span class="bolder blue-text">コース<br class="brsp">ター</span><br /><span class="light">入場者特典</span>
                </div>
              </div>
              <div class="live">
                <div class="inner"><span class="bolder blue-text">シーク<br class="brsp">レット<br class="brsp">ライブ</span><br /><span
                    class="light">S席・2F席</span></div>
              </div>
              <div class="farewell align-center">
                <div class="inner"><span class="bolder blue-text">お見送り</span><br /><span
                    class="light">S席・A席<span class="forpc">・</span><br class="brsp">1Fベンチシート<span class="forpc">・</span><br class="brsp">2F席</span></div>
              </div>
            </div>
            <template v-for="(item, index) in $store.state.schedule">
              <template v-for="(event, i) in item.events">
                <div class="row" :key="`row-${index}-${i}`" v-if="event">
                  <div class="date" v-if="firstEvent(item.events, i)">
                    <div class="month" v-html="month(item.date)"></div>
                    <div class="day" v-html="day(item.date)"
                      :class="[{ ml: isOneDigit(item.date) }, { holiday: isHoliday(item.date) }]"></div>
                  </div>
                  <div class="date same-day" v-else>
                    <div class="month"></div>
                    <div class="day">&nbsp;</div>
                  </div>
                  <div class="time" v-html="time[i]" :class="`${unitCode[event]}Bg`"></div>
                  <div class="coaster" v-html="coaster(item.live, item.present, i)"
                    :class="coasterColor(item.live, item.present, i)"></div>
                  <div class="live" v-html="live(item.live, i)" :class="`${unitCode[event]}BgLite`"></div>
                  <div class="farewell" v-html="item.farewell[i]"></div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="divider wide refly"></div>
        <div class="repeater">
          <div class="head">回数別特典</div>
          <span class="bolder">公演をたくさんご観劇いただいたお客様には、感謝を込めて下記特典をご用意いたしました。<br />
            お引換には、ご観劇いただいたチケットの半券が必要になります。</span>
          <hr class="divider" />
          <span class="sq">■</span><span class="bolder">３ユニット観劇特典</span><br />
          <span class="bolder">対象</span>：MAISY・Re:Fly・エメ☆カレ公演を<span
            class="bolder blue-text">それぞれ1回ずつ、計3回</span>ご観劇いただいたお客様<br />
          <span class="bolder">内容</span>：MAISY・Re:Fly・エメ☆カレの各ユニットブロマイド、3種の中からお好きな1種をプレゼント！<br />
          <img src="img/3unit_bro.png" class="tokuten-bro" />
          <div class="tokuten-bro-text">※画像はイメージです。実際の商品とは異なる場合があります。</div>
          <span class="sq">■</span><span class="bolder">同じユニット5回観劇特典</span><br />
          <span class="bolder">対象</span>：<span class="bolder blue-text">同じユニットの公演を計5回</span>ご観劇いただいたお客様<br />
          <span class="bolder">内容</span>：ご観劇いただいたユニットのメッセージ動画をプレゼント！<br />
          <ul class="large">
            <li>※動画は各ユニット1種ずつとなります。</li>
          </ul>
          <br />
          <span class="sq">■</span><span class="bolder">同じユニット全通特典</span><br />
          <span class="bolder">対象</span>：<span class="bolder blue-text">同じユニットの公演全11回</span>をご観劇いただいたお客様<br />
          <span class="bolder">内容</span>：各ユニットの千秋楽公演にて、終演後ご観劇いただいたタイトルユニットと一緒に写真を1枚撮影し、その場でプレゼント！<br />
          <ul class="large">
            <li>※撮影はこちらでご用意したインスタントカメラにて行います。</li>
            <li>※立ち位置やポーズなどの細かいご希望には添えませんのでご了承ください。</li>
            <li>※シークレットライブやお見送りが終了した後の対応になりますため、終演してからお写真撮影までお時間をいただきます。お帰りの時間には十分お気を付けください。</li>
          </ul>
        </div>

      </div>
    </div>
    <div class="footer-bar">
      <div class="text box">©coly／ジュエルステージ「オンエア！」製作委員会</div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
export default {
  name: "Event",
  components: {
    Header,
  },
  data: () => ({
    dayText: ["日", "月", "火", "水", "木", "金", "土"],
    time: ["13:00", "14:00", "18:00", "19:00"],
    eventBg: { "m": "maisyBg", "r": "reflyBg", "e": "emekareBg" },
    unitCode: { "m": "maisy", "r": "refly", "e": "emekare" }
  }),
  methods: {
    month(date) {
      if (!date) { return; }
      let [, m,] = date.split('-');
      let firstday = "2023-07-15";
      let firstdayofAug = "2023-08-01";
      if (date === firstday || date === firstdayofAug) {
        let month = Number(m);
        return `${month}<span class="forpc">／</span><span class="forsp">/</span>`;
      }
    },
    day(date) {
      if (!date) { return; }
      let dt = new Date(date);
      let holiday = "2023-07-17";
      let dayofweek = this.dayText[dt.getDay()];
      let day = dt.getDate();
      let dayText = `${day}`;
      if (date === holiday) {
        return `${dayText}<span class="smaller2">(${dayofweek}<span class="kakko2">・</span>祝)</span>`;
      } else {
        return `${dayText}<span class="smaller2">(${dayofweek})</span>`;
      }
    },
    isHoliday(date) {
      let holiday = "2023-07-17";
      let dt = new Date(date);
      let dayofweek = dt.getDay();

      if (dayofweek === 0 || date === holiday) {
        return true;

      }
    },
    eventText(event) {
      return this.$store.state.eventNames[event];
    },
    eventColor(event) {
      if (event) {
        return this.eventBg[event];
      } else {
        return 'blank';
      }
    },
    coaster(live, present, index) {
      let unit = this.unitCode[live[index]];
      if (present) {
        if (present[index]) {
          return this.$store.state.channelNames[unit];
        }
      }
    },
    coasterColor(live, present, index) {
      let unit = this.unitCode[live[index]];
      if (present) {
        if (present[index]) {
          return `${unit}BgLite`;
        }
      }
    },
    live(live, index) {
      if (live) {
        let unit = this.unitCode[live[index]];
        return this.$store.state.channelNames[unit];
      }
    },
    present(event, present, index) {
      let unit = this.unitCode[event];
      if (present) {
        if (present[index]) {
          return `${unit}-circle`;
        }
      }
      // return `../img/${unit}/circle-coaster.svg`;
    },
    presentImg(event) {
      let unit = this.unitCode[event];
      return `../img/${unit}/circle-coaster.svg`;
    },
    firstEvent(events, i) {
      let j = 0;
      let found = -1;
      for (let event of events) {
        if (event) {
          found = j;
          break;
        }
        j++;
      }
      if (found === i) {
        return true;
      }
      return false;
    },
    isOneDigit(date) {
      let [, , d] = date.split('-');
      if (Number(d) < 10) {
        return true;
      }
      return false;
    }
  },
}
</script>
<style scoped lang="scss">
.main {
  width: 100%;
  margin: 0 auto;
  position: relative;
  line-height: 1.7;

  @media screen and (max-width: 768px) {
    background-size: 200% auto !important;
    background-position: 50% 0 !important;
  }

  background: url(../../public/img/haikei_mre.jpg) repeat;
  background-size: 100% auto;
  background-position: 0 0;
  background-attachment: fixed;
}

.header-component {
  position: relative;
  z-index: 2;
}

.event {
  padding-top: 107px;
  position: relative;
  color: $black;
  padding-bottom: 5rem;
  font-size: 1rem;

  &-inner {
    padding-left: 4rem;
    padding-right: 4rem;
    text-align: left;
    color: $black;
    // padding-bottom: 3rem;
    line-height: 1.7;
    font-size: 1rem;

    @media screen and (max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
      font-size: 0.9rem;
    }

    .item {
      @media screen and (max-width: 768px) {
        margin-bottom: 0.5rem;
      }
    }
  }

  ul {
    margin-top: 1rem;

    &.large {
      margin-top: 0;

      li {
        font-size: 1em;
        text-indent: -1em;
      }
    }
  }

  li {
    font-size: 0.8em;

  }
}

.ticket-info {
  padding-bottom: 3rem;

  .title-link-text {
    text-transform: uppercase;
    color: $blue;
    transition: 0.33s;

    &:hover {
      color: $black;
      cursor: pointer;
    }
  }

  .mitt {
    margin-top: 1.5rem;
    // font-size: 0.8em;
  }
}

.divider.wide {
  padding-bottom: 0;
}

.event-schedule {
  background-color: $white-op5;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding-left: calc(50vw - 50%);
  padding-right: calc(50vw - 50%);
  text-align: center;

  @media screen and (max-width: 768px) {

    padding-top: 2rem;
  }
}

.bonus-item {
  margin-bottom: 1.5rem;
}

.seat-s {
  margin-right: 1px;
}

.seat-b {
  margin-right: 1px;
}

.bench {
  margin-right: -0.5px;
}

.seat-2f {
  margin-right: 2px;
}

.sq {
  color: $liteblue;
  margin-right: 0.2em;
}

hr.divider {
  border: 0;
  border-top: 1px dotted $black;
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

.divider.wide {
  margin-top: 4px;
}
.tokuten-image-box {
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  .tokuten-image {
    width: calc(100% / 3);
    margin-top: 2rem;
    padding-right: 1rem;
    @media screen and (max-width: 768px) {
      width: 70%;
      margin: 1rem auto 1rem;
    }
    &:last-child {
      @media screen and (max-width: 768px) {
        margin-bottom: 0;
      }
    }
  }
}
.tokuten-bro {
  margin-top: 2rem;
  width: 55%;
  @media screen and (max-width: 768px) {
      width: 80%;
      margin: 1rem auto 0;
    }
}
.tokuten-bro-text, .tokuten-coaster-text {
  font-size: 0.8rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
  @media screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
}
.event-title {
  margin-top: 3rem;
  position: relative;

  .smaller {
    font-size: 0.6em;
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    background: url(../../public/img/refly/title_refly.png) no-repeat;
    width: 44px;
    height: 68px;
    bottom: 0;
    left: 4 * $rem;

    @media screen and (min-width: 1024px) {
      left: 4rem;
    }

    @media screen and (max-width: 768px) {
      left: 0;
      background-size: calc(44px * .8) calc(68px * .8);
      height: calc(68px * .8);
    }
  }

  &::after {
    transform: scaleX(-1);
    right: 4 * $rem;
    left: unset;

    @media screen and (max-width: 768px) {
      right: 0;
    }
    @media screen and (min-width: 1024px) {
      right: 4rem;
    }
  }
}

.head {
  margin-top: 4rem;
  width: 100%;
  background: linear-gradient(to right, $liteblue 50%, transparent);
  padding: 0.05rem 0.5rem 0.125rem;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: left;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    background: linear-gradient(to right, $liteblue 80%, transparent);
    margin-top: 2rem;
    margin-bottom: 1rem;
    line-height: 1.4;
  }

  &.narrow {
    // width: 50%;
    margin-bottom: 0;
  }
}

.title-text {
  font-size: 2.5rem;
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1;

  @media screen and (max-width: 768px) {
    font-size: 1.6rem;
    padding-top: 0;
  }
}

.schedule-title-jp {
  font-size: 1.1rem;
  padding-bottom: 3rem;
  @media screen and (max-width: 768px) {
    font-size: 1rem;
    padding-bottom: 1.5rem;
    margin-top: -0.5rem;
  }
}

.event-table {
  padding-bottom: 4rem;
  font-size: 1 * $rem;

  @media screen and (max-width: 768px) {
    font-size: 2 * $rem;
    line-height: 1.3;
  }

  @media screen and (min-width: 1024px) {
    font-size: 1rem;
  }

  .row {
    display: flex;

    &:first-child {
      @media screen and (max-width: 768px) {
      font-size: 1em;
      }
      .inner {
        padding-bottom: 1rem;
        .light {
          @media screen and (max-width: 768px) {
            display: block;
            margin-top: 0.5rem;
            font-size: 0.9em;
          }
        }
        @media screen and (max-width: 768px) {
          padding-bottom: 0.25rem;
        }
      }
    }

    &:not(:first-child)>div:not(.same-day) {
      border-top: 2px solid $black-op3;
    }

    &:last-child {
      border-bottom: 2px solid $black-op3;
    }

    &>div {
      padding-top: 0.1 * $rem;
      padding-bottom: 0.1 * $rem;
      @media screen and (max-width: 768px) {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
      }
      @media screen and (min-width: 1024px) {
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
      }
    }

    .date {
      width: 15%;
      font-weight: 600;
      display: flex;
      justify-content: center;
      color: $black;

      @media screen and (max-width: 768px) {
        width: 23%;
        font-size: 1.2em;
      }

      .month {
        width: 25%;
        text-align: right;
      }

      .day {
        width: 75%;
        justify-self: flex-start;
        text-align: left;

        &.ml {
          margin-left: 0.8em;
        }

        &.holiday {
          color: $orange;
        }
      }
      
    }

    .time {
      width: 11%;
      font-weight: 600;
      color: white;
      @media screen and (max-width: 768px) {
        width: 12%;
      }
    }
    .coaster.emekareBgLite,
    .live.emekareBgLite {
      font-size: 0.9em;
    }
    .coaster {
      width: 19%;
      font-weight: 600;
      border-right: 1px dotted $black;
      @media screen and (max-width: 768px) {
        width: 18%;
      }
    }

    .live {
      width: 20%;
      font-weight: 600;
      border-right: 1px dotted $black;
      @media screen and (max-width: 768px) {
        width: 19%;
      }
    }

    .farewell {
      width: 36%;
      @media screen and (max-width: 768px) {
        width: 27%;
      }
    }

    &:not(:first-child) .farewell {
      text-align: left;
      padding-left: 2 * $rem;
      @media screen and (max-width: 768px) {
        padding-left: 0.25rem;
      }
      @media screen and (min-width: 1024px) {
        padding-left: 2rem;
      }
    }
  }
}

.attention {
  padding-left: 4rem;
  padding-right: 4rem;
  text-align: left;
  color: $black;
  font-size: 1.1rem;
}

.footer-bar {
  font-size: 0.7rem;
  background: url(../../public/img/mre_menu.png) no-repeat;
  background-size: 100% 100%;
  background-position: center top;
  opacity: 0.8;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  text-align: left;

  .text {
    padding: 1rem 0;
    font-size: 0.7rem;
    padding-left: 4rem;
    padding-right: 4rem;
    color: white;
  }
}</style>